import { zipCodeDirective } from './zip';
import permissions from '../constants/permissions';
import { permissionDirectiveCreator } from './permissionDirectiveCreator';

/**
 * Common directives
 */
angular
  .module('sbsf.directives', ['services.permissions'])
  .directive('zipCode', zipCodeDirective)
  .directive('backupPermissionChecker', [
    '$compile',
    'permissionService',
    permissionDirectiveCreator(permissions.BACKUP)
  ])
  .directive('exportPermissionChecker', [
    '$compile',
    'permissionService',
    permissionDirectiveCreator(permissions.EXPORT)
  ])
  .directive('metadataComparePermissionChecker', [
    '$compile',
    'permissionService',
    permissionDirectiveCreator(permissions.METADATA_COMPARE)
  ])
  .directive('restorePermissionChecker', [
    '$compile',
    'permissionService',
    permissionDirectiveCreator(permissions.RESTORE)
  ])
  .directive('settingsPermissionChecker', [
    '$compile',
    'permissionService',
    permissionDirectiveCreator(permissions.SETTINGS)
  ])
  .directive('apiUsagePermissionChecker', [
    '$compile',
    'permissionService',
    permissionDirectiveCreator(permissions.API_USAGE)
  ])
  .directive('rolesPermissionChecker', ['$compile', 'permissionService', permissionDirectiveCreator(permissions.ROLES)])
  .directive('activityHistoryPermissionChecker', [
    '$compile',
    'permissionService',
    permissionDirectiveCreator(permissions.ACTIVITY_HISTORY)
  ])
  .directive('gdprPermissionChecker', ['$compile', 'permissionService', permissionDirectiveCreator(permissions.GDPR)])
  .directive('externalApiKeysPermissionChecker', [
    '$compile',
    'permissionService',
    permissionDirectiveCreator(permissions.EXTERNAL_API_CREDENTIALS)
  ])
  .directive('itCompleteFeaturePermissionChecker', [
    '$compile',
    'permissionService',
    permissionDirectiveCreator(permissions.IT_COMPLETE_FEATURE)
  ]);
